module.exports = __webpack_public_path__ + "img/zhu_xc8.674b2710.jpg";